// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cBHD2","list":"styles_list__Xef5-","listWrapper":"styles_listWrapper__1Io9z","box":"styles_box__dERAO"};